import React, { useState } from 'react';

const VARIANTS = [
  {
    name: 'sad dood',
    label: 'when the chart does that thing',
    mouth: 'M 40,78 Q 50,70 60,78',
    eyeMod: { ly: 60, ry: 60 },
    extras: (
      <>
        <path d="M 36,62 Q 34,72 36,68" stroke="#4a9eff" strokeWidth="2" fill="none" strokeLinecap="round" />
        <path d="M 64,62 Q 66,72 64,68" stroke="#4a9eff" strokeWidth="2" fill="none" strokeLinecap="round" />
      </>
    ),
    brows: (
      <>
        <line x1="30" y1="46" x2="42" y2="50" stroke="#1a1a1a" strokeWidth="2.5" strokeLinecap="round" />
        <line x1="58" y1="50" x2="70" y2="46" stroke="#1a1a1a" strokeWidth="2.5" strokeLinecap="round" />
      </>
    ),
  },
  {
    name: 'euphoric dood',
    label: 'just saw 1000% in 4 hours',
    mouth: 'M 35,72 Q 50,90 65,72 Z',
    mouthFill: true,
    eyeMod: { ly: 55, ry: 55, eyeSize: 5 },
    extras: (
      <>
        <text x="15" y="30" fontSize="14" fontFamily="Caveat" fill="#1a1a1a" transform="rotate(-20, 15, 30)">✨</text>
        <text x="78" y="28" fontSize="14" fontFamily="Caveat" fill="#1a1a1a" transform="rotate(15, 78, 28)">✨</text>
      </>
    ),
    brows: (
      <>
        <path d="M 30,44 Q 37,36 44,44" stroke="#1a1a1a" strokeWidth="2" fill="none" strokeLinecap="round" />
        <path d="M 56,44 Q 63,36 70,44" stroke="#1a1a1a" strokeWidth="2" fill="none" strokeLinecap="round" />
      </>
    ),
  },
  {
    name: 'rugged dood',
    label: 'lost it all. still here.',
    mouth: 'M 38,78 Q 50,70 62,78',
    eyeMod: { ly: 58, ry: 58 },
    extras: (
      <>
        <line x1="36" y1="54" x2="42" y2="60" stroke="#1a1a1a" strokeWidth="2.5" strokeLinecap="round" />
        <line x1="42" y1="54" x2="36" y2="60" stroke="#1a1a1a" strokeWidth="2.5" strokeLinecap="round" />
        <line x1="58" y1="54" x2="64" y2="60" stroke="#1a1a1a" strokeWidth="2.5" strokeLinecap="round" />
        <line x1="64" y1="54" x2="58" y2="60" stroke="#1a1a1a" strokeWidth="2.5" strokeLinecap="round" />
        <text x="72" y="40" fontSize="10" fontFamily="Caveat" fill="#1a1a1a" transform="rotate(8, 72, 40)">rip</text>
      </>
    ),
    brows: null,
    noEyes: true,
  },
  {
    name: 'revenge trade dood',
    label: 'this time it\'s different (it\'s not)',
    mouth: 'M 38,72 Q 50,80 55,70',
    eyeMod: { ly: 56, ry: 54, eyeSize: 4.5 },
    extras: (
      <>
        <text x="70" y="30" fontSize="11" fontFamily="Permanent Marker" fill="#c62828" transform="rotate(5, 70, 30)">!</text>
        <text x="78" y="38" fontSize="9" fontFamily="Permanent Marker" fill="#c62828" transform="rotate(-3, 78, 38)">!</text>
      </>
    ),
    brows: (
      <>
        <line x1="30" y1="50" x2="44" y2="44" stroke="#1a1a1a" strokeWidth="3" strokeLinecap="round" />
        <line x1="56" y1="44" x2="70" y2="50" stroke="#1a1a1a" strokeWidth="3" strokeLinecap="round" />
      </>
    ),
  },
  {
    name: 'locked in dood',
    label: 'hasn\'t blinked in 6 hours',
    mouth: 'M 40,75 L 60,75',
    eyeMod: { ly: 56, ry: 56, eyeSize: 5.5 },
    extras: (
      <>
        <circle cx="39" cy="56" r="10" fill="none" stroke="#1a1a1a" strokeWidth="1" opacity="0.3" />
        <circle cx="61" cy="56" r="10" fill="none" stroke="#1a1a1a" strokeWidth="1" opacity="0.3" />
        <text x="50" y="30" textAnchor="middle" fontSize="8" fontFamily="Caveat" fill="#1a1a1a" opacity="0.5">focused</text>
      </>
    ),
    brows: (
      <>
        <line x1="30" y1="44" x2="46" y2="44" stroke="#1a1a1a" strokeWidth="2.5" strokeLinecap="round" />
        <line x1="54" y1="44" x2="70" y2="44" stroke="#1a1a1a" strokeWidth="2.5" strokeLinecap="round" />
      </>
    ),
  },
  {
    name: 'chart watching dood',
    label: 'refresh. refresh. refresh.',
    mouth: 'M 42,74 Q 50,72 58,74',
    eyeMod: { ly: 57, ry: 57 },
    extras: (
      <>
        {/* Tiny chart next to face */}
        <polyline
          points="70,65 74,60 78,68 82,50 86,55 90,45"
          fill="none"
          stroke="#4caf50"
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <text x="80" y="42" fontSize="8" fontFamily="Caveat" fill="#4caf50">↑</text>
      </>
    ),
    brows: (
      <>
        <path d="M 30,46 Q 37,42 44,46" stroke="#1a1a1a" strokeWidth="2" fill="none" strokeLinecap="round" />
        <path d="M 56,46 Q 63,42 70,46" stroke="#1a1a1a" strokeWidth="2" fill="none" strokeLinecap="round" />
      </>
    ),
  },
];

function VariantCard({ variant }) {
  const [hovered, setHovered] = useState(false);
  const tilt = React.useMemo(() => (Math.random() - 0.5) * 8, []);

  return (
    <div
      className="variant-card"
      style={{ transform: `rotate(${tilt}deg) scale(${hovered ? 1.05 : 1})` }}
      onMouseEnter={() => setHovered(true)}
      onMouseLeave={() => setHovered(false)}
    >
      <svg viewBox="0 0 100 100" width="140" height="140">
        {/* Body */}
        <path
          d="M 25,85 Q 10,80 12,60 Q 8,45 18,35 Q 22,20 35,18 Q 45,10 55,12 Q 68,10 78,22 Q 90,32 88,50 Q 92,65 82,78 Q 78,88 65,90 Q 50,95 35,90 Z"
          fill="#f5f3ee"
          stroke="#1a1a1a"
          strokeWidth="2.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />

        {/* Eyes (unless X eyes) */}
        {!variant.noEyes && (
          <>
            <ellipse cx="39" cy={variant.eyeMod.ly} rx="7" ry="8" fill="white" stroke="#1a1a1a" strokeWidth="2" />
            <circle cx="39" cy={variant.eyeMod.ly} r={variant.eyeMod.eyeSize || 4} fill="#1a1a1a" />
            <circle cx="37" cy={variant.eyeMod.ly - 2} r="1.5" fill="white" />
            <ellipse cx="61" cy={variant.eyeMod.ry} rx="7" ry="8" fill="white" stroke="#1a1a1a" strokeWidth="2" />
            <circle cx="61" cy={variant.eyeMod.ry} r={variant.eyeMod.eyeSize || 4} fill="#1a1a1a" />
            <circle cx="59" cy={variant.eyeMod.ry - 2} r="1.5" fill="white" />
          </>
        )}

        {/* Brows */}
        {variant.brows}

        {/* Mouth */}
        <path
          d={variant.mouth}
          fill={variant.mouthFill ? '#1a1a1a' : 'none'}
          stroke="#1a1a1a"
          strokeWidth="2.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />

        {/* Extras */}
        {variant.extras}

        {/* Arms */}
        <path d="M 18,60 Q 8,58 10,65" fill="none" stroke="#1a1a1a" strokeWidth="2.5" strokeLinecap="round" />
        <path d="M 82,58 Q 92,56 90,63" fill="none" stroke="#1a1a1a" strokeWidth="2.5" strokeLinecap="round" />

        {/* Feet */}
        <ellipse cx="38" cy="92" rx="8" ry="3" fill="#f5f3ee" stroke="#1a1a1a" strokeWidth="2" />
        <ellipse cx="62" cy="92" rx="8" ry="3" fill="#f5f3ee" stroke="#1a1a1a" strokeWidth="2" />
      </svg>

      <h3 className="variant-name">{variant.name}</h3>
      <p className="variant-label">{variant.label}</p>

      {/* Hand-drawn border */}
      {hovered && (
        <svg className="variant-hover-border" viewBox="0 0 200 250" preserveAspectRatio="none">
          <path
            d="M 5,5 L 195,8 L 192,245 L 8,242 Z"
            fill="none"
            stroke="#1a1a1a"
            strokeWidth="2"
            strokeLinecap="round"
            strokeDasharray="8 4"
          />
        </svg>
      )}
    </div>
  );
}

export default function DoodVariants() {
  return (
    <section className="variants-section">
      <div className="variants-header">
        <svg viewBox="0 0 450 55" width="420" height="50">
          <text
            x="225"
            y="38"
            textAnchor="middle"
            fontFamily="'Permanent Marker', cursive"
            fontSize="32"
            fill="#1a1a1a"
            transform="rotate(-1, 225, 38)"
          >
            THE MANY MOODS OF DOOD
          </text>
          <path
            d="M 30,48 Q 120,55 225,46 Q 330,38 420,50"
            fill="none"
            stroke="#1a1a1a"
            strokeWidth="2.5"
            strokeLinecap="round"
          />
        </svg>
        <p className="variants-subheader">every one of these is you at some point</p>
      </div>

      <div className="variants-grid">
        {VARIANTS.map((v, i) => (
          <VariantCard key={i} variant={v} />
        ))}
      </div>
    </section>
  );
}
